/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_Q6Inputs */

const en_to_xml_faq_q6 = /** @type {(inputs: To_Xml_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I convert the XML back to JSON?`)
};

const ko_to_xml_faq_q6 = /** @type {(inputs: To_Xml_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML을 다시 JSON으로 변환할 수 있나요?`)
};

const ja_to_xml_faq_q6 = /** @type {(inputs: To_Xml_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML を JSON に戻せますか`)
};

/**
* | output |
* | --- |
* | "Can I convert the XML back to JSON?" |
*
* @param {To_Xml_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_q6 = /** @type {((inputs?: To_Xml_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_q6(inputs)
	if (locale === "ko") return ko_to_xml_faq_q6(inputs)
	return ja_to_xml_faq_q6(inputs)
});